<template>
  <div class="home">
    <pageTop></pageTop>

    <div ref="banner" class="banner content-item-block">
      <div class="video-wrapper">

        <video
            class="video"
            preload="auto"
            muted
            loop
            playsinline
            autoplay
            poster="//juanxiuhe.oss-cn-beijing.aliyuncs.com/web/bannerbg.jpg"
            src="//juanxiuhe.oss-cn-beijing.aliyuncs.com/dibao/home.mp4"
            tabindex="-1"
        ></video>

      </div>
      <h1 class="banner-title">

        专注直播,奔赴热爱
        <div class="subTitle">JOIN EAST·DB</div>
      </h1>
      <div class="search">
        <img  @click="searchJobs" src="@/assets/images/06.png" style="width: 160px;">
<!--        <input-search @search="searchJobs" size="small" placeholder="输入城市或职位进行搜索"></input-search>-->
      </div>
      <div class="arrow-down" @click="scrollDown()"></div>

    </div>

    <!-- 字节生活 -->
    <div class="byteLife content-item-block">


      <div class="block-item block-item-one">
        <div class="block-item-column block-item-column-text">
          <h2 class="block-item-column-title">核心业务</h2>
          <div class="content">
            <div class="content-item">
              <h2 class="content-item-title">品牌策略与设计</h2>
              <p class="content-item-desc">为客户提供品牌定位、品牌形象设计、VI设计等全方位的品牌策略服务。</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">数字营销</h2>
              <p class="content-item-desc">包括搜索引擎优化（SEO）、搜索引擎营销（SEM）、社交媒体营销（SMM）、内容营销等，帮助客户在数字化时代抢占市场先机。</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">影视制作</h2>
              <p class="content-item-desc">提供广告片、宣传片、微电影等影视作品的策划、拍摄与制作服务，助力客户通过视觉传播提升品牌影响力。</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">公关活动</h2>
              <p class="content-item-desc">策划并执行各类线下活动、公关活动、新闻发布会等，增强品牌的市场影响力与公信力。</p>
            </div>

            <div class="content-item">
              <h2 class="content-item-title">数据分析与洞察</h2>
              <p class="content-item-desc">通过大数据分析，提供市场调研、消费者洞察等服务，帮助客户制定精准的营销策略。</p>
            </div>
          </div>
        </div>
        <div class="block-item-column block-item-column-image">
          <img src="@/assets/images/img.png" alt />
        </div>
      </div>
    </div>

    <!-- 员工故事 -->
    <div class="staffStory content-item-block">
      <h2 class="title">和公司同行</h2>
      <ul class="staffStory-list clearfix">
        <router-link
          tag="li"
          :to="`/staff-stories/${item.id}`"
          v-for="item in staffStories"
          :key="item.id"
          class="staffStory-item"
        >
          <div class="avatar">
            <img width="100%" :src="item.avatar" alt srcset />
          </div>
          <div class="text">
            <h2 class="title">{{ item.title }}</h2>
            <div class="desc">{{ item.name }}&nbsp;|&nbsp;{{ item.department }}</div>
            <p class="remark">{{ item.remark }}</p>
          </div>
          <div class="circular-button">→</div>
        </router-link>
      </ul>
    </div>
    <Footer ></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";

export default {
  name: "home",
  components: {pageTop, Footer},
  data() {
    return {
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: [
          {
          id: "1",
          avatar:
            "//lf3-cdn-tos.bytescm.com/obj/eden-cn/lmeh7pfuho/campus/story_shenchi_avatar.png",
          title: "从大学老师到算法工程师",
          name: "沈池",
          department: "AI - Lab 图像算法",
          remark:
            "怀着一颗想出来闯荡的心，从学术界跳到了工业界；公司有着丰富的应用场景和海量数据资源，技术落地非常有保证。"
         },
        {
          id: "2",
          avatar:
              "//lf3-cdn-tos.bytescm.com/obj/eden-cn/lmeh7pfuho/campus/story_gill_avatar.png",
          title: "在多元兼容的环境里持续成长",
          name: "Gill",
          department: "国际化产品经理",
          remark:
              "不同文化背景下的沟通是一种挑战，公司鼓励多元兼容，提倡集思广益，让我看到了广大可能性和成长空间。"
        },
        {
          id: "3",
          avatar:
              "//lf3-cdn-tos.bytescm.com/obj/ttfe/ATSX/mainland/story/story3_avatar2x_1576834857749.jpg",
          title: "在这里，看见更大的世界",
          name: "左儒哲",
          department: "飞书 - 客户端",
          remark:
              "比起其他公司，地保可能更浪漫，或者说，有更大的梦想。这里不设边界，只要连接人与信息的事情，我们都会尝试…。"
        }
      ]
    };
  },
  created() {
    const fetchProducts = this.request
      .get("/products")
      .then(response => {
        this.products = response;
      })
      .catch();
    const fetchJobCategories = this.request
      .get("/job-categories")
      .then(response => {
        this.jobCategories = response;
      });
    this.request.get("/byte-standards").then(response => {
      this.byteStandards = response;
    });
    // this.request.get("/staff-stories").then(response => {
    //   this.staffStories = response;
    // });
  },
  methods: {
    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({ name: "jobs", params: { keyword } });
    },
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    }
  },
  mounted() {
    const rootVm = this.$root;
    rootVm.$emit(
      "home-scrolling",
      { directionX: 1, directionY: -1 },
      { x: document.body.scrollLeft, y: document.body.scrollTop }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
  },
  destroyed() {
    this.unwatch();
  }
};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>

</style>
